/*
 * Owlkrown - auto-scrolling partner logo marquee.
 *
 * Turns any multicolumn section carrying the custom class "logo-marquee" into a
 * seamless row that scrolls to the left on its own. Speed is fixed in pixels per
 * second, so adding or removing a logo in the theme editor changes the length of
 * the loop, never the pace. Nothing here is hard-coded to a particular logo.
 */
(function () {
  var SPEEDS = [50, 38]; // px/second, applied to the marquees in DOM order
  var resizeTimer = null;

  function relayout() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { init(); }, 200);
  }

  function buildTrack(section, speed) {
    var track = section.querySelector('.f-grid');
    if (!track) return;

    // Keep a pristine copy of the authored logos so repeated layouts never compound.
    if (!track.owlkrownOriginals) {
      track.owlkrownOriginals = Array.prototype.slice.call(track.children);
    }
    var originals = track.owlkrownOriginals;
    if (!originals.length) return;

    track.classList.remove('f-grid--animate');
    track.style.removeProperty('--marquee-distance');
    track.style.removeProperty('--marquee-duration');

    while (track.firstChild) track.removeChild(track.firstChild);
    originals.forEach(function (node) {
      track.appendChild(node);
    });

    // Width of exactly one authored set, each item's trailing gap included, so
    // travelling that distance lands on a pixel-identical frame.
    var setWidth = originals.reduce(function (sum, node) {
      var styles = window.getComputedStyle(node);
      return sum + node.getBoundingClientRect().width + (parseFloat(styles.marginRight) || 0);
    }, 0);
    if (!setWidth) return;

    // Enough copies that the track always overflows the viewport, however wide.
    var copies = Math.max(2, Math.ceil((window.innerWidth * 2) / setWidth));
    for (var i = 1; i < copies; i++) {
      originals.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(clone.querySelectorAll('a'), function (link) {
          link.setAttribute('tabindex', '-1');
        });
        track.appendChild(clone);
      });
    }

    track.style.setProperty('--marquee-distance', setWidth + 'px');
    track.style.setProperty('--marquee-duration', setWidth / speed + 's');
    track.classList.add('f-grid--animate');
  }

  // Rebuilding the track never changes the section's own width, so watching the
  // section is safe here. This catches zoom and any layout shift that changes the
  // available width without a window resize event; the observer is parked on the
  // element so it cannot be garbage-collected while it is still observing.
  function watch(section) {
    if (!window.ResizeObserver || section.owlkrownObserver) return;
    var last = Math.round(section.getBoundingClientRect().width);
    section.owlkrownObserver = new ResizeObserver(function (entries) {
      var width = Math.round(entries[0].contentRect.width);
      if (width === last) return;
      last = width;
      relayout();
    });
    section.owlkrownObserver.observe(section);
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('.logo-marquee');
    Array.prototype.forEach.call(sections, function (section, index) {
      buildTrack(section, SPEEDS[index % SPEEDS.length]);
      watch(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('resize', relayout);
  window.addEventListener('orientationchange', relayout);

  // Theme editor re-renders a section in place when its settings change.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.logo-marquee')) init(event.target);
  });
})();
